import { render, staticRenderFns } from "./ExerciseLaunch.vue?vue&type=template&id=46311d0f"
import script from "./ExerciseLaunch.vue?vue&type=script&lang=js"
export * from "./ExerciseLaunch.vue?vue&type=script&lang=js"
import style0 from "./ExerciseLaunch.vue?vue&type=style&index=0&id=46311d0f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports